// AlmostExpiredRow.jsx
import { Button, Chip, Paper, Stack, Typography } from '@mui/material'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import moment from 'moment'

const AlmostExpiredRow = ({ item, onRemove }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 1,
        border: '1px solid',
        borderColor: 'warning.light',
        bgcolor: 'rgba(242, 139, 31, 0.06)',
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        alignItems={{ xs: 'stretch', md: 'center' }}
        justifyContent="space-between"
        gap={1}
      >
        <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
          <WarningAmberIcon color="warning" fontSize="small" />
          <Typography fontWeight={700}>{item.name}</Typography>
          {item.size && (
            <Typography color="text.secondary">{item.size}</Typography>
          )}
          <Chip
            size="small"
            color="warning"
            label={`Expires ${moment(item.expiryDate).format('DD/MM/YYYY')}`}
          />
        </Stack>
        <Button
          color="warning"
          variant="outlined"
          onClick={() => onRemove(item)}
          size="small"
          startIcon={<DeleteOutlineIcon />}
        >
          Remove item
        </Button>
      </Stack>
    </Paper>
  )
}

export default AlmostExpiredRow
